export default "__VITE_ASSET__B_dC5GEm__"